import { useEffect, useState } from 'react';
import { screens } from 'tailwindcss/defaultTheme';

export type TailwindScreenKey = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

export const useBreakpoint = (screenKey: TailwindScreenKey) => {
  const query = `(min-width: ${screens[screenKey]})`;
  const getMatches = (query: string): boolean => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  };

  const [matches, setMatches] = useState<boolean>(getMatches(query));

  useEffect(() => {
    const handleChange = () => {
      setMatches(getMatches(query));
    };

    const matchMedia = window.matchMedia(query);

    handleChange();

    matchMedia.addEventListener('change', handleChange);

    return () => {
      matchMedia.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
};
